/* eslint-disable */

export const COUNTRIES = [
    {
        label: 'Afghanistan',
        value: 'AF',
        language: 'PS',
    },
    {
        label: 'Albania',
        value: 'AL',
        language: 'SQ',
    },
    {
        label: 'Antarctica',
        value: 'AQ',
        language: '',
    },
    {
        label: 'Algeria',
        value: 'DZ',
        language: 'AR',
    },
    {
        label: 'American Samoa',
        value: 'AS',
        language: 'SM',
    },
    {
        label: 'Andorra',
        value: 'AD',
        language: 'CA',
    },
    {
        label: 'Angola',
        value: 'AO',
        language: 'PT',
    },
    {
        label: 'Antigua and Barbuda',
        value: 'AG',
        language: 'EN',
    },
    {
        label: 'Azerbaijan',
        value: 'AZ',
        language: 'AZ',
    },
    {
        label: 'Argentina',
        value: 'AR',
        language: 'ES',
    },
    {
        label: 'Australia',
        value: 'AU',
        language: 'EN',
    },
    {
        label: 'Austria',
        value: 'AT',
        language: 'DE',
    },
    {
        label: 'The Bahamas',
        value: 'BS',
        language: 'EN',
    },
    {
        label: 'Bahrain',
        value: 'BH',
        language: 'AR',
    },
    {
        label: 'Bangladesh',
        value: 'BD',
        language: 'BN',
    },
    {
        label: 'Armenia',
        value: 'AM',
        language: 'HY',
    },
    {
        label: 'Barbados',
        value: 'BB',
        language: 'EN',
    },
    {
        label: 'Belgium',
        value: 'BE',
        language: 'NL',
    },
    {
        label: 'Bhutan',
        value: 'BT',
        language: 'DZ',
    },
    {
        label: 'Bolivia',
        value: 'BO',
        language: 'ES',
    },
    {
        label: 'Bosnia and Herzegovina',
        value: 'BA',
        language: 'BS',
    },
    {
        label: 'Botswana',
        value: 'BW',
        language: 'EN',
    },
    {
        label: 'Brazil',
        value: 'BR',
        language: 'PT',
    },
    {
        label: 'Belize',
        value: 'BZ',
        language: 'EN',
    },
    {
        label: 'Solomon Islands',
        value: 'SB',
        language: 'EN',
    },
    {
        label: 'Brunei',
        value: 'BN',
        language: 'MS',
    },
    {
        label: 'Bulgaria',
        value: 'BG',
        language: 'BG',
    },
    {
        label: 'Myanmar (Burma)',
        value: 'MM',
        language: 'MY',
    },
    {
        label: 'Burundi',
        value: 'BI',
        language: 'RN',
    },
    {
        label: 'Belarus',
        value: 'BY',
        language: 'BE',
    },
    {
        label: 'Cambodia',
        value: 'KH',
        language: 'KM',
    },
    {
        label: 'Cameroon',
        value: 'CM',
        language: 'FR',
    },
    {
        label: 'Canada',
        value: 'CA',
        language: 'EN',
    },
    {
        label: 'Cape Verde',
        value: 'CV',
        language: 'PT',
    },
    {
        label: 'Central African Republic',
        value: 'CF',
        language: 'FR',
    },
    {
        label: 'Sri Lanka',
        value: 'LK',
        language: 'SI',
    },
    {
        label: 'Chad',
        value: 'TD',
        language: 'FR',
    },
    {
        label: 'Chile',
        value: 'CL',
        language: 'ES',
    },
    {
        label: 'China',
        value: 'CN',
        language: 'ZH',
    },
    {
        label: 'Christmas Island',
        value: 'CX',
        language: 'EN',
    },
    {
        label: 'Cocos (Keeling) Islands',
        value: 'CC',
        language: 'EN',
    },
    {
        label: 'Colombia',
        value: 'CO',
        language: 'ES',
    },
    {
        label: 'Comoros',
        value: 'KM',
        language: 'AR',
    },
    {
        label: 'Republic of the Congo',
        value: 'CG',
        language: 'FR',
    },
    {
        label: 'Democratic Republic of the Congo',
        value: 'CD',
        language: 'FR',
    },
    {
        label: 'Cook Islands',
        value: 'CK',
        language: 'EN',
    },
    {
        label: 'Costa Rica',
        value: 'CR',
        language: 'ES',
    },
    {
        label: 'Croatia',
        value: 'HR',
        language: 'HR',
    },
    {
        label: 'Cyprus',
        value: 'CY',
        language: 'EL',
    },
    {
        label: 'Czechia',
        value: 'CZ',
        language: 'CS',
    },
    {
        label: 'Benin',
        value: 'BJ',
        language: 'FR',
    },
    {
        label: 'Denmark',
        value: 'DK',
        language: 'DA',
    },
    {
        label: 'Dominica',
        value: 'DM',
        language: 'EN',
    },
    {
        label: 'Dominican Republic',
        value: 'DO',
        language: 'ES',
    },
    {
        label: 'Ecuador',
        value: 'EC',
        language: 'ES',
    },
    {
        label: 'El Salvador',
        value: 'SV',
        language: 'ES',
    },
    {
        label: 'Equatorial Guinea',
        value: 'GQ',
        language: 'ES',
    },
    {
        label: 'Ethiopia',
        value: 'ET',
        language: 'AM',
    },
    {
        label: 'Eritrea',
        value: 'ER',
        language: 'TI',
    },
    {
        label: 'Estonia',
        value: 'EE',
        language: 'ET',
    },
    {
        label: 'South Georgia and the South Sandwich Islands',
        value: 'GS',
        language: 'EN',
    },
    {
        label: 'Fiji',
        value: 'FJ',
        language: 'EN',
    },
    {
        label: 'Finland',
        value: 'FI',
        language: 'FI',
    },
    {
        label: 'France',
        value: 'FR',
        language: 'FR',
    },
    {
        label: 'French Polynesia',
        value: 'PF',
        language: 'FR',
    },
    {
        label: 'French Southern and Antarctic Lands',
        value: 'TF',
        language: 'FR',
    },
    {
        label: 'Djibouti',
        value: 'DJ',
        language: 'FR',
    },
    {
        label: 'Gabon',
        value: 'GA',
        language: 'FR',
    },
    {
        label: 'Georgia',
        value: 'GE',
        language: 'KA',
    },
    {
        label: 'The Gambia',
        value: 'GM',
        language: 'EN',
    },
    {
        label: 'Germany',
        value: 'DE',
        language: 'DE',
    },
    {
        label: 'Ghana',
        value: 'GH',
        language: 'EN',
    },
    {
        label: 'Kiribati',
        value: 'KI',
        language: 'EN',
    },
    {
        label: 'Greece',
        value: 'GR',
        language: 'EL',
    },
    {
        label: 'Grenada',
        value: 'GD',
        language: 'EN',
    },
    {
        label: 'Guam',
        value: 'GU',
        language: 'EN',
    },
    {
        label: 'Guatemala',
        value: 'GT',
        language: 'ES',
    },
    {
        label: 'Guinea',
        value: 'GN',
        language: 'FR',
    },
    {
        label: 'Guyana',
        value: 'GY',
        language: 'EN',
    },
    {
        label: 'Haiti',
        value: 'HT',
        language: 'HT',
    },
    {
        label: 'Heard Island and McDonald Islands',
        value: 'HM',
        language: 'EN',
    },
    {
        label: 'Vatican City',
        value: 'VA',
        language: 'IT',
    },
    {
        label: 'Honduras',
        value: 'HN',
        language: 'ES',
    },
    {
        label: 'Hungary',
        value: 'HU',
        language: 'HU',
    },
    {
        label: 'Iceland',
        value: 'IS',
        language: 'IS',
    },
    {
        label: 'India',
        value: 'IN',
        language: 'HI',
    },
    {
        label: 'Indonesia',
        value: 'ID',
        language: 'ID',
    },
    {
        label: 'Iraq',
        value: 'IQ',
        language: 'AR',
    },
    {
        label: 'Ireland',
        value: 'IE',
        language: 'EN',
    },
    {
        label: 'Israel',
        value: 'IL',
        language: 'HE',
    },
    {
        label: 'Italy',
        value: 'IT',
        language: 'IT',
    },
    {
        label: "Cote d'Ivoire",
        value: 'CI',
        language: 'FR',
    },
    {
        label: 'Jamaica',
        value: 'JM',
        language: 'EN',
    },
    {
        label: 'Japan',
        value: 'JP',
        language: 'JA',
    },
    {
        label: 'Kazakhstan',
        value: 'KZ',
        language: 'KK',
    },
    {
        label: 'Jordan',
        value: 'JO',
        language: 'AR',
    },
    {
        label: 'Kenya',
        value: 'KE',
        language: 'SW',
    },
    {
        label: 'South Korea',
        value: 'KR',
        language: 'KO',
    },
    {
        label: 'Kuwait',
        value: 'KW',
        language: 'AR',
    },
    {
        label: 'Kyrgyzstan',
        value: 'KG',
        language: 'KY',
    },
    {
        label: 'Laos',
        value: 'LA',
        language: 'LO',
    },
    {
        label: 'Lebanon',
        value: 'LB',
        language: 'AR',
    },
    {
        label: 'Lesotho',
        value: 'LS',
        language: 'ST',
    },
    {
        label: 'Latvia',
        value: 'LV',
        language: 'LV',
    },
    {
        label: 'Liberia',
        value: 'LR',
        language: 'EN',
    },
    {
        label: 'Libya',
        value: 'LY',
        language: 'AR',
    },
    {
        label: 'Liechtenstein',
        value: 'LI',
        language: 'DE',
    },
    {
        label: 'Lithuania',
        value: 'LT',
        language: 'LT',
    },
    {
        label: 'Luxembourg',
        value: 'LU',
        language: 'LB',
    },
    {
        label: 'Madagascar',
        value: 'MG',
        language: 'MG',
    },
    {
        label: 'Malawi',
        value: 'MW',
        language: 'NY',
    },
    {
        label: 'Malaysia',
        value: 'MY',
        language: 'MS',
    },
    {
        label: 'Maldives',
        value: 'MV',
        language: 'DV',
    },
    {
        label: 'Mali',
        value: 'ML',
        language: 'FR',
    },
    {
        label: 'Malta',
        value: 'MT',
        language: 'MT',
    },
    {
        label: 'Mauritania',
        value: 'MR',
        language: 'AR',
    },
    {
        label: 'Mauritius',
        value: 'MU',
        language: 'EN',
    },
    {
        label: 'Mexico',
        value: 'MX',
        language: 'ES',
    },
    {
        label: 'Monaco',
        value: 'MC',
        language: 'FR',
    },
    {
        label: 'Mongolia',
        value: 'MN',
        language: 'MN',
    },
    {
        label: 'Moldova',
        value: 'MD',
        language: 'RO',
    },
    {
        label: 'Montenegro',
        value: 'ME',
        language: 'SR',
    },
    {
        label: 'Morocco',
        value: 'MA',
        language: 'AR',
    },
    {
        label: 'Mozambique',
        value: 'MZ',
        language: 'PT',
    },
    {
        label: 'Oman',
        value: 'OM',
        language: 'AR',
    },
    {
        label: 'Namibia',
        value: 'NA',
        language: 'EN',
    },
    {
        label: 'Nauru',
        value: 'NR',
        language: 'NA',
    },
    {
        label: 'Nepal',
        value: 'NP',
        language: 'NE',
    },
    {
        label: 'Netherlands',
        value: 'NL',
        language: 'NL',
    },
    {
        label: 'New Caledonia',
        value: 'NC',
        language: 'FR',
    },
    {
        label: 'Vanuatu',
        value: 'VU',
        language: 'BI',
    },
    {
        label: 'New Zealand',
        value: 'NZ',
        language: 'EN',
    },
    {
        label: 'Nicaragua',
        value: 'NI',
        language: 'ES',
    },
    {
        label: 'Niger',
        value: 'NE',
        language: 'FR',
    },
    {
        label: 'Nigeria',
        value: 'NG',
        language: 'EN',
    },
    {
        label: 'Niue',
        value: 'NU',
        language: 'NIU',
    },
    {
        label: 'Norfolk Island',
        value: 'NF',
        language: 'EN',
    },
    {
        label: 'Norway',
        value: 'NO',
        language: 'NB',
    },
    {
        label: 'Northern Mariana Islands',
        value: 'MP',
        language: 'EN',
    },
    {
        label: 'United States Minor Outlying Islands',
        value: 'UM',
        language: 'EN',
    },
    {
        label: 'Federated States of Micronesia',
        value: 'FM',
        language: 'EN',
    },
    {
        label: 'Marshall Islands',
        value: 'MH',
        language: 'MH',
    },
    {
        label: 'Palau',
        value: 'PW',
        language: 'PAU',
    },
    {
        label: 'Pakistan',
        value: 'PK',
        language: 'UR',
    },
    {
        label: 'Panama',
        value: 'PA',
        language: 'ES',
    },
    {
        label: 'Papua New Guinea',
        value: 'PG',
        language: 'TPI',
    },
    {
        label: 'Paraguay',
        value: 'PY',
        language: 'ES',
    },
    {
        label: 'Peru',
        value: 'PE',
        language: 'ES',
    },
    {
        label: 'Philippines',
        value: 'PH',
        language: 'TL',
    },
    {
        label: 'Pitcairn Islands',
        value: 'PN',
        language: 'EN',
    },
    {
        label: 'Poland',
        value: 'PL',
        language: 'PL',
    },
    {
        label: 'Portugal',
        value: 'PT',
        language: 'PT',
    },
    {
        label: 'Guinea-Bissau',
        value: 'GW',
        language: 'PT',
    },
    {
        label: 'Timor-Leste',
        value: 'TL',
        language: 'TET',
    },
    {
        label: 'Qatar',
        value: 'QA',
        language: 'AR',
    },
    {
        label: 'Romania',
        value: 'RO',
        language: 'RO',
    },
    {
        label: 'Russia',
        value: 'RU',
        language: 'RU',
    },
    {
        label: 'Rwanda',
        value: 'RW',
        language: 'RW',
    },
    {
        label: 'Saint Helena, Ascension and Tristan da Cunha',
        value: 'SH',
        language: 'EN',
    },
    {
        label: 'Saint Kitts and Nevis',
        value: 'KN',
        language: 'EN',
    },
    {
        label: 'Saint Lucia',
        value: 'LC',
        language: 'EN',
    },
    {
        label: 'Saint Pierre and Miquelon',
        value: 'PM',
        language: 'FR',
    },
    {
        label: 'Saint Vincent and the Grenadines',
        value: 'VC',
        language: 'EN',
    },
    {
        label: 'San Marino',
        value: 'SM',
        language: 'IT',
    },
    {
        label: 'Sao Tome and Principe',
        value: 'ST',
        language: 'PT',
    },
    {
        label: 'Saudi Arabia',
        value: 'SA',
        language: 'AR',
    },
    {
        label: 'Senegal',
        value: 'SN',
        language: 'FR',
    },
    {
        label: 'Serbia',
        value: 'RS',
        language: 'SR',
    },
    {
        label: 'Seychelles',
        value: 'SC',
        language: 'CRS',
    },
    {
        label: 'Sierra Leone',
        value: 'SL',
        language: 'EN',
    },
    {
        label: 'Singapore',
        value: 'SG',
        language: 'EN',
    },
    {
        label: 'Slovakia',
        value: 'SK',
        language: 'SK',
    },
    {
        label: 'Vietnam',
        value: 'VN',
        language: 'VI',
    },
    {
        label: 'Slovenia',
        value: 'SI',
        language: 'SL',
    },
    {
        label: 'Somalia',
        value: 'SO',
        language: 'SO',
    },
    {
        label: 'South Africa',
        value: 'ZA',
        language: 'ZU',
    },
    {
        label: 'Zimbabwe',
        value: 'ZW',
        language: 'EN',
    },
    {
        label: 'Spain',
        value: 'ES',
        language: 'ES',
    },
    {
        label: 'Suriname',
        value: 'SR',
        language: 'NL',
    },
    {
        label: 'Swaziland',
        value: 'SZ',
        language: 'SS',
    },
    {
        label: 'Sweden',
        value: 'SE',
        language: 'SV',
    },
    {
        label: 'Switzerland',
        value: 'CH',
        language: 'DE',
    },
    {
        label: 'Tajikistan',
        value: 'TJ',
        language: 'TG',
    },
    {
        label: 'Thailand',
        value: 'TH',
        language: 'TH',
    },
    {
        label: 'Togo',
        value: 'TG',
        language: 'FR',
    },
    {
        label: 'Tokelau',
        value: 'TK',
        language: 'TKL',
    },
    {
        label: 'Tonga',
        value: 'TO',
        language: 'TO',
    },
    {
        label: 'Trinidad and Tobago',
        value: 'TT',
        language: 'EN',
    },
    {
        label: 'United Arab Emirates',
        value: 'AE',
        language: 'AR',
    },
    {
        label: 'Tunisia',
        value: 'TN',
        language: 'AR',
    },
    {
        label: 'Turkey',
        value: 'TR',
        language: 'TR',
    },
    {
        label: 'Turkmenistan',
        value: 'TM',
        language: 'TK',
    },
    {
        label: 'Tuvalu',
        value: 'TV',
        language: 'TVL',
    },
    {
        label: 'Uganda',
        value: 'UG',
        language: 'SW',
    },
    {
        label: 'Ukraine',
        value: 'UA',
        language: 'UK',
    },
    {
        label: 'Macedonia (FYROM)',
        value: 'MK',
        language: 'MK',
    },
    {
        label: 'Egypt',
        value: 'EG',
        language: 'AR',
    },
    {
        label: 'United Kingdom',
        value: 'GB',
        language: 'EN',
    },
    {
        label: 'Guernsey',
        value: 'GG',
        language: 'EN',
    },
    {
        label: 'Jersey',
        value: 'JE',
        language: 'EN',
    },
    {
        label: 'Tanzania',
        value: 'TZ',
        language: 'SW',
    },
    {
        label: 'United States',
        value: 'US',
        language: 'EN',
    },
    {
        label: 'Burkina Faso',
        value: 'BF',
        language: 'FR',
    },
    {
        label: 'Uruguay',
        value: 'UY',
        language: 'ES',
    },
    {
        label: 'Uzbekistan',
        value: 'UZ',
        language: 'UZ',
    },
    {
        label: 'Venezuela',
        value: 'VE',
        language: 'ES',
    },
    {
        label: 'Wallis and Futuna',
        value: 'WF',
        language: 'FR',
    },
    {
        label: 'Samoa',
        value: 'WS',
        language: 'SM',
    },
    {
        label: 'Yemen',
        value: 'YE',
        language: 'AR',
    },
    {
        label: 'Zambia',
        value: 'ZM',
        language: 'EN',
    },
    {
        label: 'Curacao',
        value: 'CW',
        language: 'NL',
    },
    {
        label: 'Sint Maarten',
        value: 'SX',
        language: 'NL',
    },
    {
        label: 'Caribbean Netherlands',
        value: 'BQ',
        language: 'NL',
    },
    {
        label: 'Saint Barthelemy',
        value: 'BL',
        language: 'FR',
    },
    {
        label: 'Saint Martin',
        value: 'MF',
        language: 'FR',
    },
    {
        label: 'South Sudan',
        value: 'SS',
        language: 'EN',
    },
    {
        label: 'Sudan',
        value: 'SD',
        language: 'AR',
    },
    {
        label: 'Isle of Man',
        value: 'IM',
        language: 'EN',
    },
];
